import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae25a82a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-records-section" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trophy custom-fa-small",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = { class: "user-records" }
const _hoisted_5 = {
  key: 0,
  class: "no-records"
}

import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'

  import RecordsCard from '@/components/Dashboard/UserRecords/RecordsCard.vue'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { getRecordsBySports } from '@/utils/records'
  import { translateSports } from '@/utils/sports'

  interface Props {
    sports: ISport[]
    user: IUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    sports: null,
    user: null
  },
  setup(__props: any) {

const props = __props as {
    sports: ISport[]
    user: IUserProfile
  }

  

  const { t } = useI18n()

  const recordsBySport = computed(() =>
    getRecordsBySports(
      props.user.records,
      translateSports(props.sports, t),
      props.user.timezone,
      props.user.imperial_units
    )
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('workouts.RECORD', 2)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (Object.keys(_unref(recordsBySport)).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('workouts.NO_RECORDS')), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(recordsBySport)).sort(), (sportTranslatedLabel) => {
        return (_openBlock(), _createBlock(RecordsCard, {
          sportTranslatedLabel: sportTranslatedLabel,
          records: _unref(recordsBySport)[sportTranslatedLabel],
          key: sportTranslatedLabel,
          useImperialUnits: __props.user.imperial_units
        }, null, 8, ["sportTranslatedLabel", "records", "useImperialUnits"]))
      }), 128))
    ])
  ]))
}
}

})